import { render } from "./Btn2.vue?vue&type=template&id=40c67b3a"
import script from "./Btn2.vue?vue&type=script&lang=js"
export * from "./Btn2.vue?vue&type=script&lang=js"

import "./Btn2.vue?vue&type=style&index=0&id=40c67b3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__